import React from 'react';

import {
  FooterMode,
  WizardScreen
} from '@futrli/ui-components/components/sidebar/wizard/screens/wizard-screen/wizard-screen';
import { WizardFormError } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-error/wizard-form-error';
import { WizardFormValidationErrorSummary } from '@futrli/ui-components/components/sidebar/wizard/wizard-form-validation-error-summary/wizard-form-validation-error-summary';

import { useModifyUserContext } from '../../context/modify-user-context';
import { UserForm } from '../../../user-form/components/user-form';

interface ModifyUserFormWizardScreenProps {
  error?: string;
  onClose: () => void;
  onUpdate: () => void;
}

export const ModifyUserFormWizardScreen = ({ error, onClose, onUpdate }: ModifyUserFormWizardScreenProps) => {
  const { form, user } = useModifyUserContext();

  return (
    <WizardScreen footerMode={FooterMode.UPDATE} onCancel={onClose} onUpdate={onUpdate}>
      <>
        {error && <WizardFormError message={error} mb={3} />}
        <WizardFormValidationErrorSummary errors={form.errors} mb={3} />
        <UserForm
          disableIdentityFields
          disableOrganisations={!user.permissions.canChangeOrganisations}
          disableRole={!user.permissions.canEditRole}
          form={form}
        />
      </>
    </WizardScreen>
  );
};
